var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_474_67009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0001 12.2296C22.0001 11.5498 21.9439 10.8664 21.8239 10.1976H12.2006V14.0484H17.7114C17.4827 15.2904 16.748 16.3891 15.672 17.0872V19.5858H18.9598C20.8904 17.8442 22.0001 15.272 22.0001 12.2296Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2005 22C14.9522 22 17.2727 21.1145 18.9634 19.5859L15.6757 17.0873C14.761 17.6973 13.5801 18.0427 12.2043 18.0427C9.54261 18.0427 7.28581 16.2826 6.47606 13.9163H3.08337V16.492C4.81533 19.8689 8.34298 22 12.2005 22Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4724 13.9163C6.04503 12.6743 6.04503 11.3295 6.4724 10.0875V7.51172H3.08345C1.63641 10.3374 1.63641 13.6664 3.08345 16.4921L6.4724 13.9163Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2005 5.95732C13.6551 5.93527 15.0609 6.47174 16.1143 7.45649L19.0271 4.60145C17.1827 2.90385 14.7347 1.97055 12.2005 1.99994C8.34298 1.99994 4.81533 4.13112 3.08337 7.51161L6.47232 10.0874C7.27831 7.71738 9.53886 5.95732 12.2005 5.95732Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_474_67009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialGoogle);
export default __webpack_public_path__ + "static/media/social-google.4efb93db071ea3410310d6462978d014.svg";
export { ForwardRef as ReactComponent };